import { render, staticRenderFns } from "./FoodManagement.vue?vue&type=template&id=548055b9&scoped=true"
import script from "./FoodManagement.vue?vue&type=script&lang=js"
export * from "./FoodManagement.vue?vue&type=script&lang=js"
import style0 from "./FoodManagement.vue?vue&type=style&index=0&id=548055b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548055b9",
  null
  
)

export default component.exports